/** @file Interpolation between two angles in degrees along the shorter arc. */

/**
 * `a + d * t` where d is the signed difference `b - a` folded into [-180, 180); the result is not wrapped, so
 * t = 0 gives exactly a and t = 1 gives b up to whole turns.
 */
export function lerpAngleDeg(a: number, b: number, t: number): number {
  const d = ((((b - a) % 360) + 540) % 360) - 180;
  return a + d * t;
}
